export default __webpack_public_path__ + "media/images/linkedin-4fca4adc4c3e55a8bf8fc1fc53fa2298.svg";